import { HttpInterceptorFn } from '@angular/common/http';

import { inject } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const translate = inject(TranslateService);

  const lang = translate.currentLang || translate.defaultLang;

  const isMaintenanceRequest = req.url.includes('/api/v1/maintenance/');

  const langReq = lang
    ? req.clone({
        setHeaders: {
          'Accept-Language': lang,
        },
        params: isMaintenanceRequest
          ? req.params.set('language', lang === 'ar' ? 'ar' : 'en')
          : req.params,
      })
    : req;

  return next(langReq);
};
